document.addEventListener("turbolinks:load", () => {
  const tempMessage = document.getElementById("temp-message");

  if (tempMessage) {
    setTimeout(() => {
      tempMessage.remove();
    }, 2000);
  }
});
